var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        staticClass: "modal",
        class: _vm.value ? "show" : "hide",
        style: _vm.value
          ? "display:block;background-color:#3333337a;"
          : "display:none;",
        attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-dialog-centered modal-dialog-scrollable",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass: "modal-header d-flex flex-row align-items-center"
                },
                [
                  _c("h3", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.row_fa.fa_id
                            ? "Éditer une question"
                            : "Ajouter une question"
                        ) +
                        " "
                    )
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("m-form-select", {
                    attrs: {
                      label: "Catégorie",
                      "label-position": "top",
                      name: _vm.$Utils.randomstring("filterCategory"),
                      items: _vm.$store.state.items_fa_categories
                    },
                    model: {
                      value: _vm.row_fa.fa_category,
                      callback: function($$v) {
                        _vm.$set(_vm.row_fa, "fa_category", $$v)
                      },
                      expression: "row_fa.fa_category"
                    }
                  }),
                  _vm.categoryError
                    ? _c("div", { staticClass: "text-danger" }, [
                        _vm._v(" Merci de renseigner ce champ ")
                      ])
                    : _vm._e(),
                  _c("m-form-text", {
                    attrs: { rows: 4, label: "Question", type: "textarea" },
                    model: {
                      value: _vm.row_fa.fa_question,
                      callback: function($$v) {
                        _vm.$set(_vm.row_fa, "fa_question", $$v)
                      },
                      expression: "row_fa.fa_question"
                    }
                  }),
                  _vm.questionError
                    ? _c("div", { staticClass: "text-danger" }, [
                        _vm._v(" Merci de renseigner ce champ ")
                      ])
                    : _vm._e(),
                  _c("m-form-text", {
                    attrs: { rows: 8, label: "Réponse", type: "textarea" },
                    model: {
                      value: _vm.row_fa.fa_answer,
                      callback: function($$v) {
                        _vm.$set(_vm.row_fa, "fa_answer", $$v)
                      },
                      expression: "row_fa.fa_answer"
                    }
                  }),
                  _vm.answerError
                    ? _c("div", { staticClass: "text-danger" }, [
                        _vm._v(" Merci de renseigner ce champ ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.cancelWin }
                  },
                  [_vm._v("Annuler")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ml-2",
                    attrs: { type: "button" },
                    on: { click: _vm.updateQuestion }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.row_fa.fa_id ? "Mettre à jour" : "Créer") +
                        " "
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _c("m-message-dialog", {
          attrs: { title: "Erreur", text: _vm.dialogErrTxt },
          model: {
            value: _vm.dialogErr,
            callback: function($$v) {
              _vm.dialogErr = $$v
            },
            expression: "dialogErr"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }